import { useTranslation } from "@i18n/hooks";
import { ResetAllStagingDataButton } from "./parts/reset-all-staging-data-button";
import { ResetStagingBillingButton } from "./parts/reset-staging-billing-button";
import { ResetStagingUserProgressButton } from "./parts/reset-staging-user-progress-button";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const StagingScreen = () => {
	const { t } = useTranslation("common");
	const canRead = useHasPermissions("onlyOwnerOfRoot");

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("staging.title")}>
			<div className="flex flex-column">
				<ResetAllStagingDataButton />
				<ResetStagingUserProgressButton />
				<ResetStagingBillingButton />
			</div>
		</BaseScreen>
	);
};
